import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { LibraryHealthPage } from '@/areas/risk-management/LibraryHealth/LibraryHealthPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/risk-management/library-health/')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <LibraryHealthPage />;
}
